/* eslint-disable no-restricted-imports */
import { useEffect, useState } from 'react';

import {
  Box,
  Card,
  CardContent,
  Collapse,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core';
import { ExpandLess, ExpandMore, Search, ShoppingCart } from '@material-ui/icons';

import { calculateGatewayFee } from '../../constants/gatewayConfig';
import { useBudget } from '../../context/BudgetContext';
import { BudgetSummary } from './BudgetSummary';
import { PartsTable } from './PartsTable';
import { ServicesSection } from './ServicesSection';
import { useStyles } from './styles';

export default function BudgetParts() {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(() => {
    const saved = localStorage.getItem('budgetPartsExpanded');
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    localStorage.setItem('budgetPartsExpanded', JSON.stringify(expanded));
  }, [expanded]);

  const {
    budget: { components, additionalServices, discount, paymentType, installments = 1, gateway },
    loadingBudgetData,
    updateComponent,
    updateComponentPrice,
    updateService,
    updateServicePrice,
    calculateValueWithCardFee,
  } = useBudget();

  const [searchTerm, setSearchTerm] = useState('');

  const totalCost = (components || []).reduce((acc, comp) => acc + comp.costPrice * comp.amount, 0);

  const totalComponents = (components || []).reduce(
    (acc, comp) => acc + comp.sellPrice * comp.amount,
    0,
  );

  const totalServices = (additionalServices || []).reduce(
    (acc, service) => acc + (service.selected ? service.value : 0),
    0,
  );

  const discountPercentage = discount || 0;
  const discountAmount = (totalComponents * discountPercentage) / 100;
  const subtotalValue = totalComponents + totalServices - discountAmount;

  const isCard = paymentType === 'cartao';
  const totalValue = isCard ? calculateValueWithCardFee(subtotalValue) : subtotalValue;
  const cardFeeAmount = isCard ? totalValue - subtotalValue : 0;
  const installmentValue = totalValue / installments;

  const gatewayFeePercentage =
    isCard && gateway ? calculateGatewayFee(gateway, paymentType, installments) : 0;

  const filteredComponents = (components || []).filter((component) => {
    if (!searchTerm) return true;
    const searchLower = searchTerm.toLowerCase().trim();
    return (
      component.description?.toLowerCase().includes(searchLower) ||
      component.partNumber?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <Card className={classes.card}>
      <CardContent>
        <Box
          className={classes.header}
          style={{ cursor: 'pointer' }}
          onClick={() => setExpanded(!expanded)}
        >
          <Box className={classes.headerTitle}>
            <ShoppingCart className={classes.icon} />
            <Typography variant='h6' className={classes.title}>
              Orçamento - Peças
            </Typography>
          </Box>
          <IconButton size='small'>{expanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
        </Box>

        <Collapse in={expanded}>
          <Box marginBottom={4} marginTop={2}>
            <Box display='flex' justifyContent='space-between' alignItems='center' marginBottom={2}>
              <Typography variant='subtitle1' style={{ fontWeight: 600 }}>
                Acessórios Disponíveis para Venda
              </Typography>
              <TextField
                placeholder='Pesquisar peças...'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size='small'
                variant='outlined'
                style={{ width: 300 }}
                InputProps={{
                  startAdornment: (
                    <Box marginRight={1} display='flex' alignItems='center'>
                      <Search fontSize='small' style={{ color: '#999' }} />
                    </Box>
                  ),
                }}
              />
            </Box>

            <PartsTable
              components={filteredComponents}
              loadingBudgetData={loadingBudgetData}
              updateComponent={updateComponent}
              updateComponentPrice={updateComponentPrice}
            />

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <ServicesSection
                  additionalServices={additionalServices}
                  loadingBudgetData={loadingBudgetData}
                  updateService={updateService}
                  updateServicePrice={updateServicePrice}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <BudgetSummary
                  totalComponents={totalComponents}
                  totalServices={totalServices}
                  discountPercentage={discountPercentage}
                  discountAmount={discountAmount}
                  subtotalValue={subtotalValue}
                  isCard={isCard}
                  totalValue={totalValue}
                  cardFeeAmount={cardFeeAmount}
                  installments={installments}
                  installmentValue={installmentValue}
                  paymentType={paymentType}
                  totalCost={totalCost}
                  gatewayFeePercentage={gatewayFeePercentage}
                />
              </Grid>
            </Grid>
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
}
